import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCertificateList as _getCertificateList,
// 定时任务——列表查询
cancelCertificateTask,
// 定时任务—取消定时任务
addCertificateTask,
// 定时任务—新建定时任务
editCertificateTask,
// 定时任务—编辑定时任务
infoCertificateTask // 定时任务——任务详情
} from 'api/payroll/prove-download';
import Pagination from '_c/pagination';
import addTiming from '../component/addTiming';
export default {
  components: {
    addTiming: addTiming,
    Pagination: Pagination
  },
  props: {},
  data: function data() {
    return {
      query: {
        status: '1',
        page: 1,
        page_size: 20
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      timeData: [],
      timeDataLen: -1
    };
  },
  created: function created() {
    this.getCertificateList(1);
  },
  methods: {
    handlerBack: function handlerBack() {
      // 返回列表页
      this.$router.push({
        path: '/certificate/staff'
      });
    },
    handleClick: function handleClick() {
      this.getCertificateList(1);
    },
    getCertificateList: function getCertificateList(page) {
      var _this = this;
      // 获取数据列表
      this.query.page = page;
      _getCertificateList(this.query).then(function (res) {
        res.data.list.forEach(function (item) {
          var sendTime = new Date(item.send_time).getTime();
          var newTime = new Date().getTime();
          item.send_state = sendTime - newTime <= 1000 * 60 * 10;
        });
        _this.timeData = res.data.list;
        _this.page.total = res.data.page_data.total;
        _this.timeDataLen = _this.page.total;
        _this.$nextTick(function () {
          if (_this.$refs.wrap) _this.$refs.wrap.scrollTop = 0;
        });
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.getCertificateList(page);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.query.page_size = size;
      this.getHistoryList(1);
    },
    handleSave: function handleSave(data) {
      var _this2 = this;
      // 保存 or 新建
      var api = data.id ? editCertificateTask : addCertificateTask;
      api(data).then(function (res) {
        _this2.$refs.addTiming.handleClose();
        _this2.$message.success(res.message);
        _this2.getCertificateList(_this2.query.page);
      });
    },
    handleEdit: function handleEdit(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              res = {};
              if (!row) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return infoCertificateTask({
                id: row.id
              });
            case 4:
              data = _context.sent;
              res = data.data;
            case 6:
              _this3.$refs.addTiming.init(res);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCancel: function handleCancel(row) {
      var _this4 = this;
      // 取消发送
      cancelCertificateTask({
        id: row.id
      }).then(function (res) {
        _this4.$message.success(res.message);
        _this4.getCertificateList(_this4.query.page);
      });
    },
    handleView: function handleView(item) {
      this.$router.push({
        path: '/certificate/timing-staff-view/5',
        query: {
          id: item.id,
          name: item.name
        }
      });
    }
  }
};